<template>
    <div id="browse" style="position: relative; top: 60px; margin-left: 13px;">
        <form @submit.prevent="search(true)">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-1">
                            <dropdown label="Name Options" v-model="nameType" :options="nameOptions" />
                        </div>
                        <div class="col-md-2">
                            <text-field label="Map Name" v-model="name" css="col-md-8" />
                        </div>
                        <div class="col-md-2">
                            <text-field label="Author" v-model="author" css="col-md-8" />
                        </div>
                        <div class="col-md-1">
                            <dropdown label="Reviewed By" v-model="reviewer" :options="reviewers" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <dropdown label="Game Type" v-model="gameType" :options="gameTypes" allowNull />
                </div>
                <div class="col-md-1">
                    <dropdown label="Review Status" v-model="status" :options="statuses" />
                </div>
                <div class="col-md-1">
                    <dropdown label="Youtube Video" v-model="youtube" :options="youtubeOptions" allowNull />
                </div>
                <div class="col-md-2">
                    <dropdown label="Sort By" v-model="sortBy" :options="sortOptions" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <button class="ol-featured_button" type="submit">Search</button>
                    <button class="ol-featured_button" @click.prevent="reset">Reset</button>
                </div>
            </div>
        </form>
        <br/>
        <div class="row">
            <div v-if="maps.length" class="col-md-12">
                <strong>Showing {{ maps.length }} of {{ count }}</strong>
            </div>
            <div v-else class="col-md-12">
                <strong>No results found</strong>
            </div>
        </div>
        <div v-if="maps.length" class="row">
            <div class="col-md-12">
                <table class="table table-condensed">
                    <thead>
                        <tr>
                            <th>Map Name</th>
                            <th>Author</th>
                            <th>Filename</th>
                            <th>Game Types</th>
                            <th>Score</th>
                            <th>Release Date</th>
                            <th>Review Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="map in maps" :key="map._id">
                            <td>
                                <router-link :to="`/review/${map._id}`">{{ map.name || 'Unable to detect' }}</router-link>
                            </td>
                            <td>
                                <a href="#" @click.prevent="filterAuthor(map)">{{ map.author }}</a>
                            </td>
                            <td>
                                <a :href="`${siteUrl}/maps/${map.filename}`">{{ map.filename }}</a>
                            </td>
                            <td>{{ map.gameTypes | arrayToString }}</td>
                            <td>{{ map.score }}</td>
                            <td>{{ map.releaseDate | date }}</td>
                            <td>{{ map.createdOn | date }}</td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <pagination v-model="currentPage" :total-page="totalPages" @change="changePage" />
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from './primitives/Dropdown'
import TextField from './primitives/TextField'
import { api } from '../framework/api'
import { settings } from '../framework/settings'
import { Pagination } from 'uiv'

export default {
    components: { Dropdown, TextField, Pagination },
    props: {
        reviewMode: false,
        pAuthor: null,
        pReviewStatus: null
    },
    async created() {
        this.author = this.pAuthor;
        if(this.pReviewStatus) {
            this.status = this.pReviewStatus;
        }
        if(this.reviewMode) {
            this.sortBy = '-releaseDate';
            this.status = 'Pending';
        }

        await this.search();
        let reviewers = await api.get('reviewers');
        this.reviewers = {
            'Any': null
        }
        reviewers.data.forEach(value => {
            this.reviewers[value] = value;
        });
    },
    data() {
        return {
            siteUrl: settings.siteUrl,
            nameOptions: {
                'Starts With': 'startsWith',
                'Contains': 'contains'
            },
            statuses: {
                'Has a review': 'Submitted',
                'No Review': 'Pending',
                'All': null
            },
            sortOptions: {
                'Review Date': '-createdOn',
                'Release Date': '-releaseDate',
                'Map Name': '_name_lower',
                'Score' : '-score',
                'Author': '_author_lower'
            },
            youtubeOptions: { 'Has a video': true },
            gameTypes: {
                'Death Match': 'dm',
                'Teams': 'tms',
                'CTF': 'ctf',
                'KFC': 'kfc',
                'Tag': 'tag',
                'Historical Mission': 'hm',
                'Single Player': 'sp'
            },
            nameType: 'contains',
            name: null,
            author: null,
            gameType: null,
            reviewer: null,
            reviewers: {},
            status: 'Submitted',
            youtube: null,
            sortBy: '-createdOn',
            count: 0,
            maps: [],
            currentPage: 1,
            totalPages: 0
        }
    },
    methods: {
        changePage(event) {
            this.currentPage = event;
            this.search();
        },
        filterAuthor(map) {
            this.author = map.author;
            this.search(true);
        },
        reset() {
            this.currentPage = 1;
            this.nameType = 'contains';
            let nulls = ['author', 'name', 'gameType', 'reviewer', 'youtube'];
            for(let value of nulls) {
                this.$data[value] = null;
            }
            if(this.reviewMode) {
                this.sortBy = '-releaseDate';
                this.status = 'Pending';
            }
            else {
                this.sortBy = '-createdOn';
                this.status = 'Submitted';
            }
            this.search();
        },
        async search(resetPage = false) {
            if(resetPage) this.currentPage = 1;
            let param = { 
                page: this.currentPage,
                pageSize: 15,
                sortBy: this.sortBy,
                nameType: this.nameType,
                cdMap: false,
                status: this.status,
                author: this.author,
                name: this.name,
                reviewer: this.reviewer,
                youtube: this.youtube
            };
            if(this.gameType) {
                param[this.gameType] = true;
            }
            let results = await api.get('reviews', { params: param });
            this.maps = results.data.data;
            this.count = results.data.total;
            this.totalPages = results.data.pages;
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Browse.vue